module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      target_name__dropped: _vm.isDropped
    },
    attrs: {
      "title": _vm.params.value
    }
  }, [(_vm.justDisplayNameOfTarget) ? [_c('span', [_vm._v("\n      " + _vm._s(_vm.params.value) + "\n    ")])] : (_vm.hasTargetAction(_vm.params.data)) ? [_c('span', {
    staticClass: "audience-hub-table__target-name",
    on: {
      "click": _vm.openTarget
    }
  }, [(_vm.showPostSymbol) ? _c('v-icon', {
    attrs: {
      "color": "green",
      "medium": ""
    }
  }, [_vm._v("mdi-chart-line")]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.params.value) + "\n    ")], 1)] : [_c('span', {
    staticClass: "audience-hub-table__target-name",
    on: {
      "click": _vm.openWorkbench
    }
  }, [_vm._v("\n      " + _vm._s(_vm.params.value) + "\n    ")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd3c397"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/TargetNameRenderer.vue
// module id = 1830
// module chunks = 0